export default {
  en: {
    decimal: {
      style: 'decimal'
    }
  },
  fr: {
    decimal: {
      style: 'decimal'
    }
  }
}



// WEBPACK FOOTER //
// ./src/locales/numberFormats.js